import { type ID, selectSectionsByTab } from '@octopus-do/octopus-project-core'

import type { AppState } from '@/types'

interface SectionPlacement {
  index: number
  order: number
}

/**
 * Where a section appended to a tab goes: `index` for the relations store, `order` for the
 * section itself.
 *
 * The order is derived from the highest order in use, not from how many sections there
 * are: a tab that has had a section deleted holds fewer sections than its orders run to,
 * and reusing the count would give the new section the same order as an existing one.
 */
export const nextSectionPlacement = (
  state: AppState,
  tabId: ID
): SectionPlacement => ({
  index: selectSectionsByTab(tabId)(state).length,
  order: state.manager.project.sections
    .filter((section) => section.tabId === tabId)
    .reduce((highest, section) => Math.max(highest, section.order + 1), 0),
})
